import React from 'react'
import * as route from 'constants/routes'
import SiteLink from 'components/Common/SiteLink'
import { postEventImages2026 } from 'constants/images'

const PreviousEvent: React.FC = () => {
    return (
        <div className="flex flex-col md:flex-row bg-cyan-100">
            <div className="max-w-6xl mx-auto px-4 py-10">
                <h1 className="text-3xl md:text-4xl font-bold mb-6 text-center">Grays Run 2026</h1>
                <p className="text-center text-gray-600 mb-10 max-w-2xl mx-auto">
                    Runners of all ages joined together for a fun and energetic event. Here are some
                    highlights from the day!
                </p>

                <p className="text-center text-gray-600 mb-10 max-w-2xl mx-auto">
                    <SiteLink
                        to={route.run_2026}
                        className="text-white grays-run-bg-blue hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center my-4">
                        Full 2026 Event Details & Photos
                    </SiteLink>
                </p>

                {/* Masonry-style grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-4">
                    <img
                        src={postEventImages2026.image0096}
                        alt={`Running event - landing 2`}
                        className="w-full rounded-2xl shadow-md hover:opacity-90 transition"
                    />

                    <img
                        src={postEventImages2026.image0107}
                        alt={`Running event - landing 1`}
                        className="w-full rounded-2xl shadow-md hover:opacity-90 transition"
                    />

                    <img
                        src={postEventImages2026.image0098}
                        alt={`Running event - landing 3`}
                        className="w-full rounded-2xl shadow-md hover:opacity-90 transition"
                    />
                </div>
            </div>
        </div>
    )
}

export default PreviousEvent
